export default __webpack_public_path__ + "static/media/2.630ba0bf.jpg";